import { createTheme } from '@material-ui/core/styles'

export default createTheme({
  palette: {
    primary: {
      main: '#632336'
    },
    secondary: {
      main: '#983A54'
    }
  }
})
